// client/src/research/ResearchDescription.js
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Collapse,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

function ResearchDescription({ description }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  // If no description, don't render anything
  if (!description || description.trim() === '') return null;

  return (
    <Typography 
      variant="body1" 
      sx={{ 
        mb: 3, 
        fontStyle: 'italic',
        lineHeight: 1.6,
        color: 'var(--light-grey)',
        whiteSpace: 'pre-wrap', // Preserve line breaks
        textAlign: 'center'
      }}
    >
      {description}
    </Typography>
  );
}

export default ResearchDescription;